import { RouteItem } from '@/types/route';

export enum ActionTypes {
  SAVE_ITEMS = 'router/SAVE_ITEMS',
  CLEAR_ROUTER = 'router/CLEAR_ROUTER',
}

export interface State {
  items: RouteItem[];
}

export interface SaveItems {
  type: ActionTypes.SAVE_ITEMS;
  payload: RouteItem[];
}
export interface ClearRouter {
  type: ActionTypes.CLEAR_ROUTER;
}

export type ActionType = SaveItems | ClearRouter;
